module.exports = __webpack_public_path__ + "static/img/skill-voice.ae39c1e1.png";